<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              prop="clickhouse_profile_attribute_storage"
              :label="
                $t(
                  'DatabaseSourceSettings_Field_ClickhouseProfileAttributeStorage'
                )
              "
              :hint="
                $t(
                  'DatabaseSourceSettings_Field_ClickhouseProfileAttributeStorage_Hint'
                )
              "
            >
              <el-select v-model="model.clickhouse_profile_attribute_storage">
                <el-option
                  v-for="option in options"
                  :key="option.value"
                  :value="option.value"
                  :label="$t(option.label)"
                />
              </el-select>
            </rest-form-item>
            <rest-form-item
              prop="clickhouse_events_storage"
              :label="$t('SegmentationSettings_Field_ClickhouseEventsStorage')"
              :hint="
                $t('SegmentationSettings_Field_ClickhouseEventsStorage_Hint')
              "
            >
              <el-select v-model="model.clickhouse_events_storage">
                <el-option
                  v-for="option in eventOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="$t(option.label)"
                />
              </el-select>
            </rest-form-item>
            <rest-form-item
              prop="clickhouse_events_ignore_microseconds"
              :label="
                $t(
                  'SegmentationSettings_Field_ClickhouseEventsStorage_IgnoreMicroseconds'
                )
              "
              :hint="
                $t(
                  'SegmentationSettings_Field_ClickhouseEventsStorage_IgnoreMicroseconds_Desc'
                )
              "
            >
              <feature-toggle
                v-model="model.clickhouse_events_ignore_microseconds"
              />
            </rest-form-item>
            <rest-form-item
              prop="clickhouse_tag_storage"
              :label="$t('DatabaseSourceSettings_Field_ClickhouseTagsStorage')"
              :hint="
                $t('DatabaseSourceSettings_Field_ClickhouseTagsStorage_Hint')
              "
            >
              <el-select v-model="model.clickhouse_tags_storage">
                <el-option
                  v-for="option in options"
                  :key="option.value"
                  :value="option.value"
                  :label="$t(option.label)"
                />
              </el-select>
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint } from '@/core/helpers'
import FeatureToggle from '@/common/components/form/FeatureToggle.vue'

export default {
  name: 'DatabaseSourceSettingsPage',

  components: {
    FeatureToggle,
    RestFormPage,
    RestFormItem,
    FormSection
  },

  data() {
    return {
      model: null,
      options: [
        {
          value: 0,
          label: 'DatabaseSourceSettings_Clickhouse_Disabled'
        },
        {
          value: 1,
          label: 'DatabaseSourceSettings_Clickhouse_Primary'
        },
        {
          value: 2,
          label: 'DatabaseSourceSettings_Clickhouse_Replica'
        },
        {
          value: 4,
          label: 'DatabaseSourceSettings_Clickhouse_Standalone'
        }
      ],
      eventOptions: [
        {
          value: '',
          label: 'DatabaseSourceSettings_Clickhouse_Disabled'
        },
        {
          value: 'primary',
          label: 'DatabaseSourceSettings_Clickhouse_Primary'
        },
        {
          value: 'replica',
          label: 'DatabaseSourceSettings_Clickhouse_Replica'
        },
        {
          value: 'accelerator',
          label: 'DatabaseSourceSettings_Clickhouse_Accelerator'
        },
        {
          value: 'standalone',
          label: 'DatabaseSourceSettings_Clickhouse_Standalone'
        }
      ]
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``,
        params: {
          fields:
            'clickhouse_profile_attribute_storage,clickhouse_events_storage,clickhouse_tags_storage,clickhouse_events_ignore_microseconds'
        },
        handler: data => {
          for (const key in data) {
            // look for 'accelerator' value and set it to 'primary' for non-event settings
            if (data[key] === 3) {
              data[key] = 1
            }
          }
          this.model = data
        }
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: ``,
        params: {
          data: this.model
        }
      })
    },

    readonly() {
      return !this.$isRole('admin')
    }
  },
  methods: {
    afterSave(res, loading) {
      this.$store.dispatch('reloadProjectConfig').then(loading())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/DatabaseSourceSettingsPage.vue